import styled from 'styled-components';
import {
  SYS_BORDER_RADIUS_SM,
  SYS_BORDER_WIDTH_100,
  SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT,
} from '@oneaudi/unified-web-common';
import { Tag } from '@oneaudi/unified-web-components';

export const StyledCard = styled.div`
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.fixed300} 0;
  width: 100%;
  max-width: 332px;
  min-width: 285px;
  background-color: ${({ theme }) =>
    process.env.IS_LEGACY ? theme.global.color.canvas.default : theme.colors.cardBackground};
  ${({ theme }) =>
    !process.env.IS_LEGACY &&
    `
      border-radius: ${SYS_BORDER_RADIUS_SM};
      border: ${SYS_BORDER_WIDTH_100} solid ${theme.colors.cardStrokeColor};
      backdrop-filter: blur(20px);
    `}
`;

export const TagWrapper = styled.div`
  min-height: 28px;
  padding: 0 ${({ theme }) => theme.spacing.fixed300};
`;

export const StyledCardHeadingContainer = styled.div`
  align-content: flex-start;
`;
export const StyledCardImgWrapper = styled.a`
  display: block;
  min-height: 140px;
`;

export const StyledCardImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
`;

export const StyledGrid = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  align-items: baseline;
  margin-block-end: ${({ theme }) => theme.spacing.fixed200};
`;

export const StyledNewTag = styled(Tag)`
  background-color: ${SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT};
  color: ${({ theme }) => theme.sys.color.foreground.neutral['800']};
`;

export const StyledButtonWrapper = styled.div`
  padding-block: var(--spacing-relative-lg);
  padding-inline: var(--page-margin);
`;

export const StyledInformationSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacing.fixed300} ${({ theme }) => theme.spacing.fixed300} 0;
`;
